import api from './api';

export interface PermissionStructurePermission {
    key: string;
    label: string;
}

export interface PermissionStructureGroup {
    name: string;
    permissions: PermissionStructurePermission[];
}

export interface RolePermission {
    id?: number;
    role_name: string;
    description?: string;
    status: number;
    
    // Product
    product_index: number;
    product_create: number;
    product_update: number;
    product_delete: number;
    product_import: number;
    product_export: number;
    product_expired: number;
    product_barcode: number;
    product_label: number;
    product_qrcode: number;

    // Service
    service_index: number;
    service_create: number;
    service_update: number;
    service_delete: number;
    service_import: number;
    service_export: number;

    // Warranty
    warranty_index: number;
    warranty_create: number;
    warranty_update: number;
    warranty_delete: number;
    warranty_import: number;
    warranty_export: number;

    // Stock
    stock_index: number;
    stock_add: number;
    stock_edit: number;
    stock_delete: number;
    stock_low: number;
    
    // Adjustment
    adjustment_index: number;
    adjustment_create: number;
    adjustment_update: number;
    adjustment_delete: number;

    // Movement/Transfer
    movement_index: number;
    movement_create: number;
    movement_update: number;
    movement_delete: number;
    movement_import: number;
    movement_export: number;

    // Purchase
    purchase_index: number;
    purchase_create: number;
    purchase_update: number;
    purchase_delete: number;

    // Sale
    sale_index: number;
    sale_create: number;
    sale_update: number;
    sale_delete: number;
    sale_export: number;

    // POS Sale
    pos_sale_index: number;
    pos_sale_create: number;
    pos_sale_update: number;
    pos_sale_delete: number;
    pos_sale_export: number;

    // Quotation
    quote_index: number;
    quote_create: number;
    quote_update: number;
    quote_delete: number;
    quote_export: number;
    quote_status: number;
    quote_generation: number;

    // Coupon
    coupon_index: number;
    coupon_create: number;
    coupon_update: number;
    coupon_delete: number;
    coupon_export: number;

    // Membership Card
    membership_card_index: number;
    membership_card_create: number;
    membership_card_update: number;
    membership_card_delete: number;
    membership_card_use: number;

    // Promotion
    promotion_index: number;
    promotion_create: number;
    promotion_update: number;
    promotion_delete: number;
    promotion_use: number;

    // Discount
    discount_index: number;
    discount_create: number;
    discount_update: number;
    discount_delete: number;
    discount_status: number;
    discount_export: number;

    // Customer
    customer_index: number;
    customer_create: number;
    customer_update: number;
    customer_delete: number;
    customer_export: number;
    customer_status: number;

    // Supplier
    supplier_index: number;
    supplier_create: number;
    supplier_update: number;
    supplier_delete: number;
    supplier_export: number;

    // Warehouse
    warehouse_index: number;
    warehouse_create: number;
    warehouse_update: number;
    warehouse_delete: number;
    warehouse_export: number;

    // Role
    role_index: number;
    role_permission: number;

    // Delete Account
    delete_account_index: number;
    delete_account_update: number;
    delete_account_delete: number;

    // Reports
    report_sale: number;
    report_best_seller: number;
    report_product: number;
    report_product_expiry: number;
    report_quantity_alert: number;
    report_stock_history: number;
    report_sold_stock: number;
    report_service_history: number;
    report_invoice: number;
    report_supplier: number;
    report_customer_due: number;
    report_expense: number;
    report_income: number;
    report_tax: number;
    report_pnl: number;
    report_annual: number;

    created_at?: string;
    updated_at?: string;
}

export const getRoles = async () => {
    const response = await api.get('/role-permissions');
    return response.data;
};

export const getRole = async (id: number) => {
    const response = await api.get(`/role-permissions/${id}`);
    return response.data;
};

export const createRole = async (data: Partial<RolePermission>) => {
    const response = await api.post('/role-permissions', data);
    return response.data;
};

export const updateRole = async (id: number, data: Partial<RolePermission>) => {
    const response = await api.put(`/role-permissions/${id}`, data);
    return response.data;
};

export const deleteRole = async (id: number) => {
    const response = await api.delete(`/role-permissions/${id}`);
    return response.data;
};

export const getPermissionStructure = async (): Promise<PermissionStructureGroup[]> => {
    const response = await api.get('/role-permissions/structure');
    return response.data;
};

export default {
    getRoles,
    getRole,
    createRole,
    updateRole,
    deleteRole,
    getPermissionStructure
};
